import { mapConfig } from 'lib/config'
import { isDiffWithinTolerance, roundToPrecision } from 'utils/math'

export const isWithinMapBounds = (point: H.geo.IPoint, map: H.Map): boolean =>
  map.getViewModel().getLookAtData().bounds?.getBoundingBox()?.containsPoint(point) as boolean

export const isWithinZoomRange = (zoom: number, rangeLength: number, map: H.Map): boolean =>
  isDiffWithinTolerance(zoom, roundToPrecision(map.getZoom(), 2), rangeLength)

export const getMapPadding = (): { [key: string]: number } => {
  const screenWidth = window.innerWidth
  const screenHeight = window.innerHeight
  const defaultPadding = screenWidth / 10
  const markerHeight = mapConfig.padding.markerHeight
  const padding = {
    bottom:
      screenWidth <= mapConfig.padding.mobile.screenBreakpoint ? screenHeight / 2 : defaultPadding,
    left:
      screenWidth >= mapConfig.padding.default.screenBreakPoint
        ? mapConfig.padding.default.mapPanelWidth + defaultPadding
        : screenWidth <= mapConfig.padding.mobile.screenBreakpoint
        ? defaultPadding
        : mapConfig.padding.mobile.mapPanelWidth + defaultPadding,
    right: defaultPadding,
    top: defaultPadding + markerHeight,
  }
  return padding
}
